import React from 'react';
import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';

import Breadcrumbs from 'components/Breadcrumbs';

import { shallowEqual, useSelector } from 'react-redux';
import SubHeader from '../SubHeader';
import useStyles from './lib/useStyles';
import { selectApplicationLogo } from '../../../../reducers/Configuration';
import { selectName } from '../../../../reducers/Authorization';

const Header = ({ breadcrumbs, withSubheader, control }) => {
  const { push } = useHistory();
  const appLogo = useSelector(selectApplicationLogo);
  const name = useSelector(selectName, shallowEqual);

  const classes = useStyles();
  return (
    <AppBar>
      <Toolbar className={classes.toolbar}>
        <Box className={classes.container}>
          <Box className={classes.block} justifyContent="flex-start">
            <Box
              paddingX={2}
              onClick={() => push('/')}
              display="flex"
              alignItems="center"
              // default left logo use 'row', to make the logo on the right side, use "row-reverse"
              flexDirection="row"
              justifyContent="center"
            >
              {appLogo && name && (
                <img
                  src={`data:image/png;base64,${appLogo}`}
                  alt="Preview"
                  style={{ marginRight: '10px', maxHeight: 50, maxWidth: 50 }}
                  className={classes.img}
                />
              )}
            </Box>
          </Box>
          <Box className={classes.block} justifyContent="center">
            <Breadcrumbs list={breadcrumbs} />
          </Box>
          <Box className={classes.block} justifyContent="flex-end" />
        </Box>
        <Box className={classes.block} justifyContent="flex-end">
          {control && control}
        </Box>
      </Toolbar>
      {withSubheader && <SubHeader />}
    </AppBar>
  );
};

export default Header;
